import { useNavigate, useLocation } from "react-router-dom";

export function usePricingNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return () => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" }), 200);
    } else {
      document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
    }
  };
}
